export default __webpack_public_path__ + "images/5b7af6ef2b43f2ae4de04e701eb2617e-awareness.png";